import camelcaseKeysDeep from 'camelcase-keys-deep';
/* eslint no-use-before-define: 0 */

function findIncluded(included, { id, type }) {
  return included.find(el => el.id === id && el.type === type);
}

function normalizeRelationship(relationship, included, relations) {
  if (Array.isArray(relationship)) {
    const collection = relationship.map(rel => findIncluded(included, rel));
    return normalizeCollection(collection, included, relations);
  }
  return normalizeObject(findIncluded(included, relationship), included, relations);
}

function normalizeRelationships(relationships, included, relations) {
  return Object.keys(relationships).reduce((parsedRelationships, key) => {
    let relationsSchema = relations[key];
    if (relationsSchema && relationships[key].data) {
      if (typeof relationsSchema !== 'object') {
        relationsSchema = {};
      }
      const relationshipObject = normalizeRelationship(
        relationships[key].data,
        included,
        relationsSchema
      );
      /* eslint no-param-reassign: 0 */
      parsedRelationships[key] = relationshipObject;
    }
    return parsedRelationships;
  }, {});
}

function normalizeObject(object, included, relations) {
  const id = { id: object.id };
  let relationships = {};
  if (object.relationships) {
    relationships = normalizeRelationships(object.relationships, included, relations);
  }
  return { ...id, ...object.attributes, ...relationships };
}

function normalizeCollection(collection, included, relations) {
  return collection.map(object => camelcaseKeysDeep(normalizeObject(object, included, relations)));
}

function normalize(response, relations = {}) {
  const { data } = response;
  const included = response.included || [];
  if (Array.isArray(data)) {
    return normalizeCollection(data, included, relations);
  }
  return camelcaseKeysDeep(normalizeObject(data, included, relations));
}

export default normalize;
